<template>
    <header class="site-header">
        <div
            class="site-header__container"
            :class="[{ wt: wtActive }, { desktop: !isMobile }]"
        >
            <nav
                class="navbar navbar-user navbar-expand-lg navbar-light bg-white"
            >
                <div class="container flex-nowrap">
                    <router-link
                        :to="isLogged ? { name: 'dashboard' } : '/'"
                        class="navbar-brand"
                    >
                        <div class="main-nav__logo">
                            <img
                                class="img-fluid"
                                :src="
                                    require(`@/assets/${this.$brand.logo.headerLogo}`)
                                "
                            />
                        </div>
                    </router-link>
                    <div class="m-userNav" data-walk="1-2">
                        <div
                            v-if="isLogged && login"
                            class="m-userHello cux-exclude"
                        >
                            Witaj, {{ login }}
                        </div>
                        <user-control v-if="isLogged" />
                    </div>
                </div>
            </nav>
            <main-nav v-if="isLogged" />
        </div>
    </header>
</template>

<script>
import UserControl from '@/components/header/UserControl'
import MainNav from '@/components/header/MainNav'

export default {
    data() {
        return {
            headerHeight: 0,
            scrollTop: 0,
            isMobile: false
        }
    },
    components: {
        UserControl,
        MainNav
    },
    computed: {
        isLogged() {
            return this.$store.getters.isLogged
        },
        login() {
            return this.$store.getters.getUser?.email
        },
        wtActive() {
            return this.$store.getters.getWalkthroughActive
        }
    },
    mounted() {
        window.addEventListener('scroll', () => {
            const isModalOpened = document.querySelector('.modal-opened')
            if (isModalOpened) {
                return
            }

            this.setHeaderFixed()
        })
        this.$nextTick(() => {
            this.setHeaderHeight()
            this.setHeaderFixed()
        })

        this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    },
    methods: {
        setHeaderHeight() {
            const { $el } = this

            const siteHeader = $el

            let header
            if (window.innerWidth < 992) {
                header = $el.querySelector('.site-header__container > nav')
            } else {
                header = $el.querySelector('.site-header__container')
            }

            if (!header) {
                return
            }

            const headerHeight = header.offsetHeight
            this.headerHeight = headerHeight

            siteHeader.style.height = headerHeight + 'px'

            document.documentElement.style.setProperty(
                '--header-height',
                headerHeight + 'px'
            )
        },

        setHeaderFixed() {
            this.scrollTop = window.scrollY

            const header = this.$el.querySelector('.site-header__container')

            if (!header) {
                return
            }

            header.classList.add('fixed')
            if (this.scrollTop > 0) {
                header.classList.add('fixed')
            } else {
                header.classList.remove('fixed')
            }

            if (this.scrollTop > header.offsetHeight) {
                header.classList.add('scrolled')
            } else {
                header.classList.remove('scrolled')
            }

            setTimeout(() => {
                document.documentElement.style.setProperty(
                    '--header-height',
                    header.offsetHeight + 'px'
                )
            }, 300)
        }
    },
    watch: {
        isLogged() {
            setTimeout(() => {
                this.setHeaderHeight()
                this.setHeaderFixed()

                this.$gtag.config({
                    user_id: this.$store.getters.userId.toString()
                })
            }, 0)
        }
    }
}
</script>

<style lang="scss" scoped>
.m-userNav {
    display: flex;
    align-items: center;
}
.m-userHello {
    margin-left: auto;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 320px;
    @media screen and (max-width: 768px) {
        order: 3;
        width: 100%;
        text-align: right;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        display: none;
    }
}
</style>
